import React, { useEffect, useState } from 'react';
import {
  IonContent,
  IonPage,
  IonIcon,
  IonCard,
  IonCardContent,
  IonLoading
} from '@ionic/react';
import { checkmarkCircleOutline, closeCircleOutline } from 'ionicons/icons';
import { RouteComponentProps } from 'react-router';
import TestResultRepository, {
  ResultInfo
} from '../repositories/TestResultRepository';
import { format, formatDistanceStrict } from 'date-fns';
import fr from 'date-fns/locale/fr';

const ScanResults: React.FC<RouteComponentProps<{ resultKey: string }>> = ({
  match
}) => {
  const [resultInfo, setResultInfo] = useState<ResultInfo>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function getInfos() {
      setIsLoading(true);
      setResultInfo(
        await TestResultRepository.getTestResultInfoByKey(
          match.params.resultKey
        ).finally(() => {
          setIsLoading(false);
        })
      );
    }

    getInfos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonPage>
      <IonLoading isOpen={isLoading} />
      {resultInfo ? (
        <IonContent>
          <div className="ion-padding wrapper wrapper--large wrapper--stretch wrapper--centered-md">
            <IonCard
              color={resultInfo.result === 'GCOVN' ? 'success' : 'danger'}
            >
              <IonCardContent className="ion-text-center">
                <div>
                  <IonIcon
                    icon={
                      resultInfo.result === 'GCOVN'
                        ? checkmarkCircleOutline
                        : closeCircleOutline
                    }
                    color="light"
                    style={{ fontSize: '84px' }}
                  />
                </div>
                <p
                  style={{
                    fontSize: '32px',
                    textTransform: 'uppercase',
                    fontWeight: 'bold'
                  }}
                >
                  {resultInfo?.result_label}
                </p>
                <h1>
                  Testé il y a{' '}
                  {formatDistanceStrict(resultInfo.tested_at, new Date(), {
                    locale: fr
                  })}
                  <br />
                  <small>
                    {format(resultInfo.tested_at, 'PPPP', { locale: fr })}
                  </small>
                </h1>
                <hr color="white" className="ion-margin-top" />
                <p style={{ fontSize: '24px', fontWeight: 'bold' }}>
                  {resultInfo.fullname}
                </p>
                <p style={{ fontSize: '24px' }}>
                  né•e le {format(resultInfo.tested_at, 'P', { locale: fr })}
                </p>
              </IonCardContent>
            </IonCard>
          </div>
        </IonContent>
      ) : null}
    </IonPage>
  );
};

export default ScanResults;
